module.exports = __webpack_public_path__ + "static/media/CourseNewCourseGrey.a5d24ab9.svg";